var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{style:(`--order:${_vm.itemOrder ?? 99}`)},[_c('NavigationLink',{attrs:{"route":_vm.route}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }